module.exports = __webpack_public_path__ + "static/screenshot2-ec95fb8a658339f712d1f2dc458d542a.png";